module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "definition-controls"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.groupDisable || _vm.isDragAndDropActive,
      "title": "Group (g)"
    },
    on: {
      "click": _vm.groupAttributes
    }
  }, [_c('svg-icon', {
    attrs: {
      "id": "definition-controls__group",
      "icon": _vm.group,
      "width": 18,
      "height": 18
    }
  })], 1), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.ungroupDisable || _vm.isDragAndDropActive,
      "title": "Ungroup (u)"
    },
    on: {
      "click": _vm.ungroupAttributes
    }
  }, [_c('svg-icon', {
    attrs: {
      "id": "definition-controls__ungroup",
      "icon": _vm.ungroup,
      "width": 18,
      "height": 18
    }
  })], 1), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.countGroupDisable || _vm.isDragAndDropActive
    },
    on: {
      "click": _vm.countGroupHandler
    }
  }, [_c('svg-icon', {
    attrs: {
      "icon": _vm.countGroupIcon,
      "width": 18,
      "height": 18
    }
  })], 1), _vm._v(" "), _c('button', {
    class: {
      active: _vm.isDragAndDropActive
    },
    attrs: {
      "title": "Drag and drop mode"
    },
    on: {
      "click": _vm.dragAndDropModeToggle
    }
  }, [_c('svg-icon', {
    attrs: {
      "id": "definition-controls__arrows",
      "icon": _vm.arrows
    }
  })], 1), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.deleteDisable || _vm.isDragAndDropActive,
      "title": "Delete (Delete/Backspace)"
    },
    on: {
      "click": _vm.deleteAttributes
    }
  }, [_c('svg-icon', {
    attrs: {
      "id": "definition-controls__trash",
      "icon": _vm.trash,
      "width": 15,
      "height": 18
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c380012","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/targetDefinition/components/DefinitionControls.vue
// module id = 2032
// module chunks = 0